<div class="card card-custom">
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label">{{ data.type | titlecase }} List</h3>
    </div>
    <div class="mt-2">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput #search />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>
  <div class="card-body">
    <div class="mat-table-wrapper">
      <mat-table
        class="lmat-elevation-z8"
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="desc"
        matSortDisableClear
        style="min-width: 600px"
      >
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef translate="CATEGORY.TABLE.ID">ID</mat-header-cell>
          <mat-cell *matCellDef="let teamMember">{{ teamMember.id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef>Profile</mat-header-cell>
          <mat-cell *matCellDef="let teamMember">
            <kt-user-photo
              [create]="false"
              [size]="26"
              [type]="'object'"
              [editable]="false"
              [user$]="teamMember"
            ></kt-user-photo>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell
            *matHeaderCellDef
            style="justify-content: left"
            translate="CATEGORY.TABLE.NAME"
            >Name
          </mat-header-cell>
          <mat-cell *matCellDef="let teamMember" style="justify-content: left">{{
            teamMember.name | titlecase
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="hasBiAccess">
          <mat-header-cell *matHeaderCellDef style="justify-content: left"
            >Has BI Access
          </mat-header-cell>
          <mat-cell
            *matCellDef="let teamMember"
            style="justify-content: left"
            [ngClass]="{
              'text-success': teamMember.hasBiAccess,
              'text-danger': !teamMember.hasBiAccess
            }"
          >
            {{ teamMember.hasBiAccess ? 'YES' : 'NO' }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let teamMember">
            <span
              class="label label-inline label-light-{{
                teamMember.status | userStatusColor
              }} font-weight-bold"
              >{{ teamMember.status | userStatus }}</span
            >
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell
            *matHeaderCellDef
            style="justify-content: left"
            translate="CATEGORY.TABLE.EMAIL"
            >Email
          </mat-header-cell>
          <mat-cell *matCellDef="let teamMember" style="justify-content: left">{{
            teamMember.email
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef>{{ 'Actions' }} </mat-header-cell>
          <mat-cell *matCellDef="let teamMember" class="clickable">
            <button
              *ngIf="teamMember.status"
              matTooltip="Block User"
              type="button"
              (click)="block(teamMember)"
              class="btn btn-light btn-hover-danger btn-sm"
            >
              Block
            </button>
            <button
              *ngIf="!teamMember.status"
              matTooltip="Unblock User"
              type="button"
              (click)="unblock(teamMember)"
              class="btn btn-danger btn-sm"
            >
              Unblock
            </button>
            &nbsp;
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div
        class="mat-table-message"
        *ngIf="this.dataSource.length === 0 && !loading"
        translate="GLOBAL.NO_RECORDS_FOUND"
      >
        No Records Found
      </div>
      <div class="mat-table-message" *ngIf="loading" translate="GLOBAL.PLEASE_WAIT">
        Please Wait...
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button (click)="dialogRef.close()" type="button" mat-raised-button>
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
